import { useMutation } from '@apollo/client';
import type { ApiOptions } from '../helpers';
import { ExportAuditLogsDocument } from './export.generated';

export const useExportAuditLogs = (options: ApiOptions<typeof ExportAuditLogsDocument> = {}) =>
  useMutation(ExportAuditLogsDocument, {
    ...options,
  });
